import React from "react";
import { Dropdown, Menu } from "antd";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import Link from "next/link";

const AccelistGroupDropdown = ({ isActive }) => {
  const accelistGroupMenu = (
    <Menu>
      <Menu.Item key="page1">
        <Link href="https://www.accelist.com/Technology" className="flex justify-between items-center py-2 px-3 hover:text-primary">
          <span className="pr-2">Accelist Technology</span>
        </Link>
      </Menu.Item>
      <Menu.Item key="page2">
        <Link href="https://www.accelist.com/Aviation" className="flex justify-between items-center py-2 px-3 hover:text-primary">
          <span className="pr-2">Accelist Aviation</span>
        </Link>
      </Menu.Item>
      <Menu.Item key="page3">
        <Link href="https://edukasi.accelist.com/" className="flex justify-between items-center py-2 px-3 hover:text-primary">
          <span className="pr-2">Accelist Edukasi Indonesia</span>
        </Link>
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown overlay={accelistGroupMenu} trigger={['click']} placement="bottomLeft">
      <span className={`cursor-pointer block py-2 sm:px-3 px-1 rounded hover:bg-primary hover:bg-transparent md:border-0 hover:text-primary md:p-0 hover:underline hover:decoration-2 hover:underline-offset-4 decoration-primary ${
                        isActive
                        ? "text-primary underline decoration-2 underline-offset-4 sm:text-sm text-xs"
                        : "text-gray-400 sm:text-sm text-xs"
                    }`}>
        Accelist Group <FontAwesomeIcon icon={faChevronDown} className="inline" />
      </span>
    </Dropdown>
  );
};

export default AccelistGroupDropdown;
